module.exports = __webpack_public_path__ + "img/dab_lira.a8c46d2c.jpg";